import { parseNumber } from "common/utils/numbers";
import { IPatient, PatientStatus } from "common/types";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useCreatePatientMutation } from "../../hooks";
import PetForm from "../forms/PetForm";

const noop = () => undefined;

export type AccountCreatePetDrawerProps = {
  onSuccess?: (patient: IPatient) => void;
};

const AccountCreatePetDrawer = ({ onSuccess = noop }: AccountCreatePetDrawerProps) => {
  const { close } = useCurrentDrawer();
  const {
    mutate: createPatient,
    isPending: isCreating,
    error,
  } = useCreatePatientMutation({
    onSuccess: (patient) => {
      close();
      onSuccess(patient);
    },
  });

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Add pet" onClose={close} />
      <PetForm
        isLoading={isCreating}
        submitText="Add Pet"
        onSubmit={(values) =>
          createPatient({
            ...values,
            weight_in_units: parseNumber(values.weight_in_units, null),
            weight_unit_of_measure: values.weight_unit_of_measure,
            birth_day: parseNumber(values.birth_day, null),
            birth_month: parseNumber(values.birth_month, null),
            birth_year: parseNumber(values.birth_year, null),
            primary_breed: null,
            secondary_breeds: [],
            color: null,
            custom_breed: "",
            status: PatientStatus.Active,
            image_id: values.image?.id ?? null,
          })
        }
        error={error}
      />
    </DrawerLayout>
  );
};

export default AccountCreatePetDrawer;
